import { render, staticRenderFns } from "./ProjectWebsiteEditNewsTab.vue?vue&type=template&id=f7c777bc"
import script from "./ProjectWebsiteEditNewsTab.vue?vue&type=script&lang=ts"
export * from "./ProjectWebsiteEditNewsTab.vue?vue&type=script&lang=ts"
import style0 from "./ProjectWebsiteEditNewsTab.vue?vue&type=style&index=0&id=f7c777bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports